<template>
  <div>
    <!-- REGISTRO SOLICITUDES-->
    <v-card class="mx-auto">
      <v-system-bar color="#1973a5" dark>
        <v-flex>
          <center>REGISTRO DE SOLICITUD</center>
        </v-flex>
      </v-system-bar>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row class="mt-4 container">
          <!-- LISTA DE PACIENTES -->
          <v-col cols="12" sm="12" md="12">
            <v-autocomplete v-model="editedItem.paciente" :items="itemsDatosPaciente" @change="updatePaciente"
              item-text="nombreCompleto" item-value="dni" id="inputPaciente" dense label="PACIENTE"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-autocomplete v-model="editedItem.paciente" :items="itemsDatosPaciente" @change="updatePaciente"
              item-text="dni" item-value="dni" id="inputDNI" dense label="DNI"></v-autocomplete>
          </v-col>
          <!-- COMBOBOX TIPO SOLICITUD -->
          <v-col cols="6" sm="6" md="6">
            <v-autocomplete v-model="editedItem.tipoSolicitud" :rules="[rules.required]" :items="itemsTipoSolcitud"
              label="Tipo Solicitud"></v-autocomplete>
          </v-col>
          <!-- COMBOBOX NUEVO TURNO -->
          <v-col cols="6" sm="6" md="6" v-if="perfil == 13">
            <v-file-input v-model="editedItem.sustento" show-size :rules="[rules.required]"
              label="Ingresar Archivos"></v-file-input>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <p>
              <!-- Escriba su correo electronico para enviar constancia de envio de
              solicitud. -->
            </p>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-select v-model="itemCas" :items="itemsCas" item-value="url" item-text="descripCas" disabled
              label="Clínica"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="itemSecuencia" disabled label="Secuencia"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="itemTurno" disabled label="Turno"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="itemSerologia" disabled label="Serología"></v-text-field>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>
          <v-btn color="blue darken-1" text @click="save"> Guardar </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

    <v-dialog v-model="dialogLoad" hide-overlay persistent width="300" class="fondo-griss">
      <v-card color="primary" dark>
        <v-card-text>
          Cargando Datos
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import axios from "axios";
import Swal from "sweetalert2";
export default {
  data: () => ({
    pacienteApePat: null,
    pacienteApeMat: null,
    pacienteNombres: null,
    cupoActual: null,
    dialogLoad: false,
    actionBoton: "LIBERAR CUPO",
    nombrePaciente: [],
    editedItem: {
      //Cupos
      paciente: "",
      frecuencia: "",
      turno: "",
      nombrePaciente: "",
      correo: "",
      sustento: new FormData()
    },
    defaultItem: {
      paciente: "",
      frecuencia: "",
      turno: "",
    },
    headers: [],
    desserts: [],
    dialog: false,
    valid: true,
    expression: /\w+@\w+\.+[a-z]/,
    rules: {
      required: (v) => !!v || "Campo Obligatorio.",
      email: (v) => !!/\w+@\w+\.+[a-z]/.test(v) || "Correo invalido",
    },
    itemsDatosPaciente: [],
    itemsTurno: [],
    itemsTipoSolcitud: [],
    nombrePaciente: "",
    tab: 0,
    dialogoEliminacion: false,
    dialogCorreo: false,
    correo: "",
    dialogConfirmacion: false,
    mensaje: "Estado de solicitud actualizada con exito.",
    statusTurno: false,
    fechaRegCupoActual: null,
    archivoActual: [],
    itemsCas: [],
    itemCas: null,
    itemTurno: null,
    itemSecuencia: null,
    itemSerologia: null

  }),
  methods: {
    updatePaciente() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(
              RUTA_API + "/asigCuposPac/?search=" + this.editedItem.paciente + "+true",
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {
              if (res.data.length == 0) {
                Swal.fire({
                  title: "!Error!",
                  text: "¡El paciente no cuenta con cupo asignado!",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                });
              } else {
                this.cupoActual = res.data[0].url;
                this.fechaRegCupoActual = res.data[0].fecha_reg;
                this.pacienteApePat = res.data[0].datosPaciente.ape_pat;
                this.pacienteApeMat = res.data[0].datosPaciente.ape_mat;
                this.pacienteNombres = res.data[0].datosPaciente.nombres;
                const pacienteId = res.data[0].datosPaciente.url;
                this.loadTurnoActual(pacienteId.split("/")[4]);
              }
            })
            .catch((res) => {

            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadTurnoActual(idPaciente) {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(
              RUTA_API + "/generar_turno_actual/", { paciente_id: idPaciente },
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {
              this.itemTurno = res.data[0].turno;
              this.itemSecuencia = res.data[0].frecuencia;
              this.itemSerologia = res.data[0].tipoPuesto;
              this.itemCas = res.data[0].casId;
            })
            .catch((res) => {

            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    enviarAlCorreo(apepat, apemat, nombre) {
      let data = {
        asunto: "Mensaje de confirmacion",
        mensaje: "hola",
        destinatario: this.editedItem.correo,
        html: `<div style="width:700px;margin: 0 auto;">
                    <div style="width:700px;">
                        <img src="https://inhouse.academicovitem.com/assets/img/logos/essalud-renal.png" width="200" >
                    </div>
                    <div >
                        <h1 style="color:#007AC9;text-transform:uppercase;font-weight:600;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;text-align:center;">CONFIRMACION DE LIBERACIÓN DE CUPO</h1>
                    </div>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Este correo fue generado de forma automática por<strong style="color:#766AE0"> HISAR-SERVICE,</strong><strong style="color:#766AE0"> Por favor no responder.</strong></p>
                    <div style="width:fit-content;margin:0 auto;margin-bottom:5px;border-radius:7px;padding:10px;background-color:#E3DDFB;">  
                        <h3 style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">PACIENTE: ${apepat}  ${apemat} ${nombre}</h3>
                        
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Motivo de liberación: ${this.editedItem.tipoSolicitud}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Turno: ${this.editedItem.turno}</p>
                    </div>
                    <div style="width:500px;margin:0 auto">
                        <img src="https://blog.vantagecircle.com/content/images/2021/07/Basics-Of-Employee-Engagement-Surveys.png" width="500">
                    </div>
                    <div style="background-color:#007AC9;color:#FFF;padding-top:2px">
                        <p style="padding:5px;text-align:center;font-size:14px;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif">@HISAR-SERVICE / DSI</p>
                    </div>  
        </div>`,
      };
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/enviar-correo-adj/", data, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {

            });
        });
    },
    guardarCorreo() {

      let data = {
        cas: this.urlCas,
        usuario: this.url,
        correo: this.editedItem.correo,
      };

      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/correos/", data, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {

            });
        });
    },
    listarPacientes() {
      let urlCasId;
      if (this.urlCas.split("/")[4] == "1") {
        urlCasId = null;
      } else {
        urlCasId = this.urlCas.split("/")[4]
      }
      this.dialogLoad = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(
              RUTA_API + "/generar_lista_pacientes/",
              {
                clinica_id: urlCasId
              },
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {
              this.itemsDatosPaciente = [];
              for (let i = 0; i < res.data.length; i++) {
                this.itemsDatosPaciente.push({

                  nombreCompleto: res.data[i].nombreCompleto,
                  dni: res.data[i].dni,
                  paciente_id: res.data[i].paciente_id,
                });
              }
              this.dialogLoad = false;
            })
            .catch((res) => {
              console.warn("Error:", res);
              this.dialog = false;
              this.dialogLoad = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadCas() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/cas/", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              /* this.itemsCas = res.data; */
              this.itemsCas = res.data.map(item => {
                return {
                  ...item,        // Copiamos todas las propiedades del objeto original
                  url: Number(item.url.split("/")[4]) // Convertimos 'value' a número
                };
              });
              console.log("dasdasf", this.itemsCas);
            })
            .catch((res) => {

            })
        })
        .catch((res) => {

        });
    },
    buscarPaciente() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/paciente/?search=" + this.urlCas.split("/")[4] + "+" + this.editedItem.documento, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.nombrePaciente =
                res.data[0].ape_pat +
                " " +
                res.data[0].ape_mat +
                " " +
                res.data[0].nombres;
            })
            .catch((res) => {

            });
        })
        .catch((response) => {

        });
    },
    comboTipoSolicitud() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/maestro/?search=TS001", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              for (let i = 0; i < res.data.length; i++) {
                this.itemsTipoSolcitud.push(res.data[i].descripMaestro);
              };
            })
            .catch((res) => {

            });
        })
        .catch((response) => {

        });
    },
    comboTurnos() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/maestro/?search=TR001", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              for (let i = 0; i < res.data.length; i++) {
                this.itemsTurno.push(res.data[i].descripMaestro);
              }
            })
            .catch((res) => {
              console.log(res.data);
            });
        })
        .catch((response) => {
          console.log(response.data);
        });
    },
    close() {
      this.$emit('closeDialog');
      this.dialog = false;
      this.editedItem.paciente = "";
      this.editedItem.tipoSolicitud = "";
      this.editedItem.turno = "";
      this.editedItem.correo = "";
    },
    save() {
      if (this.cupoActual == null) {
        Swal.fire({
          title: "!Error!",
          text: "¡El paciente no cuenta con cupo asignado!",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        return;
      }
      if (
        !this.editedItem.paciente ||
        !this.editedItem.tipoSolicitud
      ) {
        this.$refs.form.validate();
        Swal.fire({
          title: "Error!",
          text: "¡Debe completar todos los campos obligatorios! (*)",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      } else {
        this.genConfirmacionLibCupo();
      }
    },
    genConfirmacionLibCupo() {
      const cupoActual = this.cupoActual.split("/")[4];
      const cupoActualEntero = parseInt(cupoActual, 10); // Usando parseInt()
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(
              RUTA_API + "/generar_confirmacion_liberacion_cupo/",
              {
                asigCuposPac_id: cupoActualEntero,
                perfil: this.perfil
              },
              {
                headers: { Authorization: this.auth }
              }
            )
            .then((res) => {
              console.log("resss", res.data);
              this.consultaEstadoCupo(res.data);
              return;

            })
            .catch((res) => {
              this.mensaje = "Error! Solicitud no ha podido ser agregada."
              this.dialogConfirmacion = true
              return false;
            });
        })
        .catch((response) => {

          response === 404
            ? console.warn("lo sentimos no tenemos servicios")
            : console.warn("Error:", response);
          return false;
        });
    },
    consultaEstadoCupo(diasTranscurridos) {
      if (diasTranscurridos.length == 0) {
        Swal.fire({
          title: "¡Error!",
          text: "¡El paciente no esta activo!",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        return;
      }
      if (diasTranscurridos[0].d >= 15) {
        axios
          .post(RUTA_API + "/api/token/", {
            username: USUARIO,
            password: PASSWORD,
          })
          .then((response) => {
            if (this.perfil == 13) {
              this.grabarConDocumento(response);
            } else {
              this.grabarSinDocumento(response);
            }

          })
          .catch((response) => {
            response === 404
              ? console.warn("lo sentimos no tenemos servicios")
              : console.warn("Error:", response);
          });
      } else {
        Swal.fire({
          title: "¡Error!",
          text: "¡El paciente no cumple con los 15 días de ausencia!",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        return;
      }

    },
    grabarConDocumento(response) {
      let InstFormData = new FormData();
      InstFormData.append('fechaTerminoCupo', new Date(Date.now())
        .toISOString()
        .substr(0, 10),);
      InstFormData.append('usuario_reg_termino', this.usuario + "|" + this.nombre);
      InstFormData.append('estado', false);
      InstFormData.append('motivo_liberacion', this.editedItem.tipoSolicitud);
      InstFormData.append('asigcupospac_id', this.cupoActual.split("/")[4]);
      InstFormData.append('sustento', this.editedItem.sustento);
      this.auth = "Bearer " + response.data.access;
      axios
        .post(
          RUTA_API + "/generar_liberacion_cupo_documento/", InstFormData,
          {
            headers: { Authorization: this.auth },
          }
        )
        .then((res) => {
          Swal.fire({
            title: "¡Exito!",
            text: "¡Se registró con exito",
            icon: "success",
            confirmButtonText: "Aceptar",
          });
          this.guardarCorreo();
          this.enviarAlCorreo(
            this.pacienteApePat,
            this.pacienteApeMat,
            this.pacienteNombres
          );
          this.mensaje = "Solicitud agregada con exito."
          this.dialogConfirmacion = true
          this.close();

          this.dialogDataApi = false;
          this.desserts = [];
          this.estadoTab = "liberados";
        })
        .catch((res) => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se registró!",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          this.dialogDataApi = false;
          this.dialogConfirmacion = true
        });
    },
    grabarSinDocumento(response) {
      this.auth = "Bearer " + response.data.access;
      axios
        .post(
          RUTA_API + "/generar_liberacion_cupo/",
          {
            asigcupospac_id: this.cupoActual.split("/")[4],
            usuario: this.usuario + "|" + this.nombre,
            motivo: this.editedItem.tipoSolicitud
          },
          {
            headers: { Authorization: this.auth },
          }
        )
        .then((res) => {
          Swal.fire({
            title: "¡Exito!",
            text: "¡Se registró con exito",
            icon: "success",
            confirmButtonText: "Aceptar",
          });
          this.guardarCorreo();
          this.enviarAlCorreo(
            this.pacienteApePat,
            this.pacienteApeMat,
            this.pacienteNombres
          );
          this.mensaje = "Solicitud agregada con exito."
          this.dialogConfirmacion = true
          this.close();

          this.dialogDataApi = false;
          this.desserts = [];
          this.estadoTab = "liberados";


        })
        .catch((res) => {
          console.log("Error1:", res);
          Swal.fire({
            title: "¡Error!",
            text: "¡No se registró!",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          this.dialogDataApi = false;
          this.mensaje = "Error! Solicitud no ha podido ser agregada."
          this.dialogConfirmacion = true
        });
    }
  },
  mounted() {
    if (!sessionStorage.getItem("keyValue")) {
      this.$router.push("/");
    }
  },
  created() {
    this.editedItem.sustento = null;
    this.perfil = sessionStorage.getItem("perfil");
    console.log("perfil actual", this.perfil);
    this.nombre = sessionStorage.getItem("nombre");
    this.url = sessionStorage.getItem("url");
    this.usuario = sessionStorage.getItem("usuario");
    this.urlCas = sessionStorage.getItem("urlCas");
    //INICIO DE CONSULTA
    this.comboTipoSolicitud();
    this.comboTurnos();
    this.listarPacientes();
    this.loadCas();
  },
  components: {},
};
</script>
